import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { SharedModule } from "src/app/shared.module";
import { UserSettingsInputsComponent } from "./user-settings-inputs.component";
import { OwlDatetimePickerModule } from "../owl-datetime-picker/owl-datetime-picker.component.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        SharedModule,
        OwlDatetimePickerModule
    ],
    declarations: [UserSettingsInputsComponent],
    exports: [UserSettingsInputsComponent]
})
export class UserSettingsInputsModule {}